import { render, staticRenderFns } from "./CRMContractBaseInfo.vue?vue&type=template&id=c202dde6&scoped=true&"
import script from "./CRMContractBaseInfo.vue?vue&type=script&lang=js&"
export * from "./CRMContractBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./CRMContractBaseInfo.vue?vue&type=style&index=0&id=c202dde6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c202dde6",
  null
  
)

export default component.exports